import React from 'react';
import { Redirect, Route, Switch } from '@react-router';

import { useHotelRoutePaths } from '@shared/utils/accommodations/hotelRoutes';
import { TelemetryProvider as HotelBookingTelemetryProvider } from './HotelBooking.telemetry';

import { LazyHotelBookingRoute } from './routes/HotelBooking/HotelBooking.lazy';
import { LazyRoomBlockHotel } from './routes/RoomBlockHotel/RoomBlockHotel.lazy';

export const HotelBookingApp: React.FC<{ eventHandle: string }> = ({ eventHandle }) => {
  const hotelRoutePaths = useHotelRoutePaths();
  return (
    <HotelBookingTelemetryProvider context={{ eventName: eventHandle }}>
      <Switch>
        <Route
          path={hotelRoutePaths.partnerhotels.path}
          render={({ match }) => {
            // Don't seen traffic in amplitude for guest.travel.hotelbookingpartner, cleaned old code. Kept redirect to hoteldetails route if in case any.
            return <Redirect to={`/${eventHandle}/hotel/${match.params.hotelId}`} />;
          }}
        />
        <Route
          path={hotelRoutePaths.roomblock.path}
          render={({ match }) => {
            return <LazyRoomBlockHotel roomBlockHotelId={match.params.id || null} />;
          }}
        />
        <Route
          path={hotelRoutePaths.hotelbooking.path}
          render={() => <LazyHotelBookingRoute eventHandle={eventHandle} />}
        />
      </Switch>
    </HotelBookingTelemetryProvider>
  );
};
